import React, { useEffect, useState } from "react";
import { isValidPhoneNumber } from "libphonenumber-js";
import AppPrimaryTextfield from "./TextInput";
import PopupDropdown from "./Dropdown";
import { AppColumn, AppRow } from "./Layouts";
import { allPhoneOptions } from "../../utils/Constants/dails";
import useTheme from "../../hooks/useTheme";
import { t } from "i18next";
import { Flag } from "semantic-ui-react";
import { SizedBox } from "./Sizes";
import AppText from "../UI/Texts/AppTexts";
import { decodePhoneNumber, normalizePhoneNumber } from "../../utils/helperFunctions";


const PhoneInput = ({ value, onChange, onCode, defaultPhoneCode, error, onPhoneValid, labelText }) => {
  const theme = useTheme();
  const [isValidPhone, setIsValidPhone] = useState(true);

  const errorText = (() => {
    if (error) {
      return error;
    } else if (!isValidPhone) {
      return t('candidatedetail.form_error.invalid_phone');
    }
  })()

  useEffect(() => {
    if (value) {
      checkPhoneNumber();
    }
  }, [value]);


  function checkPhoneNumber() {
    const fullPhoneNumber = normalizePhoneNumber(defaultPhoneCode?.value, value);
    const isValid = isValidPhoneNumber(fullPhoneNumber, defaultPhoneCode?.code, {
      defaultCallingCode: defaultPhoneCode?.value,
    });

    if (onPhoneValid) {
      onPhoneValid(isValid);
    }

    setIsValidPhone(isValid);
  }

  function cleanPhoneNumber(phoneNumber) {
    return phoneNumber.replace(/[^0-9]/g, '');
  }

  return (<AppPrimaryTextfield
    value={value ?? ""}
    labelText={labelText}
    maxLine={1}
    onInput={(value) => {
      const phoneNumber = value.target.value;

      if (phoneNumber?.startsWith('+')) {
        const decodePhone = decodePhoneNumber(phoneNumber)

        onCode(decodePhone?.code ?? '+46');
        onChange(decodePhone?.local ?? '');
      } else {
        onChange(cleanPhoneNumber(phoneNumber));
      }
    }}
    prefixIcon={(
      <PopupDropdown
        childrenBuilder={(close) => {
          return (<AppColumn>
            {allPhoneOptions().map((option) => {
              const isSelected = defaultPhoneCode?.value === option?.value;
              return (
                <AppRow crossAxisAlignment={"center"}
                  key={option?.key}
                  onClick={() => {
                    onCode(option?.value);
                    checkPhoneNumber();
                    close();
                  }}
                  style={{
                    padding: theme.spacing.elementPadding,
                    cursor: "pointer",
                  }}
                >
                  <Flag name={option?.flag} />
                  <SizedBox width={theme.spacing.elementPaddingSmall} />
                  <AppText.Footnote color={isSelected && theme.primaryColor} fontWeight={isSelected ? 600 : 400}>{option.text}</AppText.Footnote>
                </AppRow>
              );
            }
            )}

          </AppColumn>)
        }}
        customPlaceholderWithCallback={(
        ) => {
          return (
            <AppRow crossAxisAlignment={"center"}
              key={defaultPhoneCode?.key}
              style={{
                padding: theme.spacing.elementPadding,
                cursor: "pointer",
              }}
            >
              <Flag name={defaultPhoneCode?.flag} />
              <SizedBox width={'0.1rem'} />
              <AppText.Footnote color={theme.colors.dark} fontWeight={600}>{defaultPhoneCode?.text}</AppText.Footnote>
            </AppRow>
          );
        }
        }
      />

    )}
    hintText={t('candidatedetail.form.phone')}
    inputmode={'tel'}
    autoComplete="tel"
    error={errorText ?? ""}
  />)
}


export default PhoneInput;


